/**
 * components/bar.tsx — a single reusable progress/meter track + fill.
 * Used by the confidence meter, derivation progress, channel-split bars and
 * the perf mini-bars. `value` is 0..1.
 */
import React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import { LightColors as C } from '../theme/theme';

export interface BarProps {
  value: number;
  height?: number;
  trackColor?: string;
  fillColor?: string;
  style?: StyleProp<ViewStyle>;
}

const Bar: React.FC<BarProps> = ({ value, height = 8, trackColor = C.paper3, fillColor = C.ink, style }) => {
  const pct = Math.max(0, Math.min(1, value)) * 100;
  return (
    <View style={[{ height, backgroundColor: trackColor, borderRadius: 999, overflow: 'hidden' }, style]}>
      <View style={{ width: `${pct}%`, height: '100%', backgroundColor: fillColor, borderRadius: 999 }} />
    </View>
  );
};

export default Bar;
